// LiveStreamUserEnteredNotice.js
'use strict';
import { connect } from 'react-redux';
import getUserData from '../selector/getUserData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';
import getVipLevelLivestreamChatStyle from '../selector/getVipLevelLivestreamChatStyle.js';
import fetchUser from '../action/fetchUser.js';
import LiveStreamUserEnteredNotice from '../component/LiveStreamUserEnteredNotice.jsx';
import { livestreamNoticeType } from '../resource/liveStreamConstants.js';
import { FEATURE_DISPLAY_NAME } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { streamId }) => {
  const noticeType = livestreamNoticeType.USER_ENTERED_NOTICE;
  const userEnteredNoticeIds =
    getListData(state, ['liveStream', streamId, noticeType], 'itemIds') || [];
  const userEnteredNoticeId = userEnteredNoticeIds[0];
  const userEnteredNoticeSelectPath = [
    streamId,
    noticeType,
    userEnteredNoticeId,
  ];
  const noticeStatus = getLiveStreamData(
    state,
    userEnteredNoticeSelectPath,
    'status'
  );
  const userId = getLiveStreamData(
    state,
    userEnteredNoticeSelectPath,
    'userId'
  );
  const level = getLiveStreamData(state, userEnteredNoticeSelectPath, 'level');
  const username = getUserData(state, userId, 'username');
  const displayName = getUserData(state, userId, 'displayName');
  const isUserFetching = userId
    ? getNetworkingData(state, ['user', userId], 'isFetching')
    : false;
  const isUserFetched = userId
    ? getNetworkingData(state, ['user', userId], 'isFetched')
    : false;
  const isDisplayNameEnabled =
    getRemoteConfigData(state, FEATURE_DISPLAY_NAME) === 1;
  const senderBadges = getLiveStreamData(
    state,
    userEnteredNoticeSelectPath,
    'senderBadges'
  );
  const vipChatStyle = getVipLevelLivestreamChatStyle(state, level);

  const diamonds = getLiveStreamData(
    state,
    userEnteredNoticeSelectPath,
    'diamonds'
  );
  const text = getLiveStreamData(state, userEnteredNoticeSelectPath, 'text');
  return {
    userId,
    username,
    displayName,
    text,
    isUserFetching,
    isUserFetched,
    isDisplayNameEnabled,
    noticeStatus,
    level,
    diamonds,
    senderBadges,
    vipChatStyle,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: ({ userId }) => dispatch(fetchUser({ id: userId })),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamUserEnteredNotice);
